export default __webpack_public_path__ + "static/media/TradeScreenChart.04ad1ea7.svg";